import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import { SIGNUP_FORM_TYPES } from 'dpl/shared/constants/shared';
import UserAuthPageContainer from 'dpl/UserAuth/containers/UserAuthPageContainer';
import UserAuthInviteFormContainer from 'dpl/UserAuth/containers/UserAuthInviteFormContainer';
import UserAuthLoginForm from 'dpl/UserAuth/components/UserAuthLoginForm';
import UserAuthSignupForm from 'dpl/UserAuth/components/UserAuthSignupForm';
import UserAuthBreederSignupForm from 'dpl/UserAuth/components/UserAuthBreederSignupForm';
import UserAuthForgotPasswordForm from 'dpl/UserAuth/components/UserAuthForgotPasswordForm';
import UserAuthResetPasswordFormContainer from 'dpl/UserAuth/containers/UserAuthResetPasswordFormContainer';

const {
  BREEDER_SIGNUP,
  FORGOT_PASSWORD,
  INVITE,
  LOGIN,
  RESET_PASSWORD,
  SIGNUP
} = SIGNUP_FORM_TYPES;

export default function UserAuthApp() {
  return (
    <BrowserRouter basename="/auth">
      <UserAuthPageContainer>
        <Switch>
          <Route
            exact
            path={`/${BREEDER_SIGNUP}/:referredBy?`}
            component={UserAuthBreederSignupForm}
          />
          <Route exact path={`/${SIGNUP}`} component={UserAuthSignupForm} />
          <Route
            exact
            path={`/${FORGOT_PASSWORD}`}
            component={UserAuthForgotPasswordForm}
          />
          <Route
            exact
            path={`/${INVITE}/:userId/:inviteToken/:conversationId?`}
            component={UserAuthInviteFormContainer}
          />
          <Route exact path={`/${LOGIN}`} component={UserAuthLoginForm} />
          <Route
            exact
            path={`/${RESET_PASSWORD}/:resetToken`}
            component={UserAuthResetPasswordFormContainer}
          />
          <Redirect to={`/${LOGIN}`} />
        </Switch>
      </UserAuthPageContainer>
    </BrowserRouter>
  );
}
